import Deal from 'arbitrip-common/client/entities/Deal';

export default Deal;
